import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-d3a89c38"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "preview-image-wrap" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.WatermarkDensityMatrix[_ctx.wmdata.density][0], (rowItem, rowIndex) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "watermark-row",
        key: rowIndex,
        style: _normalizeStyle({ height: `${100 / _ctx.WatermarkDensityMatrix[_ctx.wmdata.density][0]}%` })
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.WatermarkDensityMatrix[_ctx.wmdata.density][1], (colItem, colIndex) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "watermark-item",
            key: colIndex,
            style: _normalizeStyle({
            width: `${100 / _ctx.WatermarkDensityMatrix[_ctx.wmdata.density][1]}%`,
            transform: `rotate(-${_ctx.wmdata.rotate_angle}deg)`,
            opacity: _ctx.wmdata.opacity / 100,
          })
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.wmdata.fields, (fieldItem, fieldIndex) => {
              return (_openBlock(), _createElementBlock("div", { key: fieldIndex }, [
                (fieldItem === _ctx.WatermarkField.custom_text)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.wmdata.custom_text), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.fieldExample(fieldItem)), 1))
              ]))
            }), 128))
          ], 4))
        }), 128))
      ], 4))
    }), 128))
  ]))
}